import { Application } from '../index'

function createPlace() {
  if (document.getElementById('property-registration')) {
    return false
  } else {
    const place = document.createElement('div')
    place.id = 'property-registration'
    place.innerHTML = Application.generateLoader()
    document.body.appendChild(place)
  }
}
function createInstance(id) {
  import(
    /* webpackChunkName: "property-registration-as" */ '../../../modules/entrys/property-registration'
  ).then(({ default: propertyRun }) => {
    propertyRun(id)
  })
}
export function propertyPopupListener() {
  document.querySelectorAll('[data-open-property-popup]').forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault()
      createPlace()
      createInstance()
    })
  })
  document.querySelectorAll('button[data-pack-id]').forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault()
      let id = undefined
      try {
        id = parseInt(button.dataset.packId)
        if (isNaN(id)) {
          id = undefined
        }
      } catch (e) {}
      createPlace()
      createInstance(id)
    })
  })
}

if (
  process.env.NODE_ENV === 'development' &&
  window.location.href.match('property.html')
) {
  setTimeout(() => {
    createPlace()
    createInstance()
  })
}
